import React from "react";

const Invoicing = () => {
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-8 md:px-8">
      <div className="mx-auto max-w-6xl rounded-2xl bg-white shadow-lg overflow-hidden">
        <div className="bg-teal-700 p-6 md:p-8">
          <h1 className="text-3xl md:text-4xl font-bold text-white">Invoicing Solution</h1>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4">
          <aside className="bg-teal-800 p-6 text-white lg:min-h-[420px]">
            <ul className="space-y-4 text-sm md:text-base">
              <li>Invoice Generation</li>
              <li>Payment Tracking</li>
              <li>Recurring Billing</li>
              <li>Tax Ready Reports</li>
            </ul>
          </aside>

          <div className="lg:col-span-3 p-6 md:p-8">
            <h2 className="text-2xl md:text-3xl font-bold text-teal-700 mb-4">
              Modern billing for growing businesses
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              Our invoicing solution helps you generate polished invoices, track
              payments, and maintain a clear record of business finances with less effort.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="rounded-xl bg-slate-100 p-5">
                <h3 className="font-bold text-lg mb-2">Quick Billing</h3>
                <p className="text-slate-600 text-sm">Create and send invoices in just a few steps.</p>
              </div>
              <div className="rounded-xl bg-slate-100 p-5">
                <h3 className="font-bold text-lg mb-2">Payment Reminders</h3>
                <p className="text-slate-600 text-sm">Reduce delays with automated follow-up reminders.</p>
              </div>
              <div className="rounded-xl bg-slate-100 p-5">
                <h3 className="font-bold text-lg mb-2">Financial Visibility</h3>
                <p className="text-slate-600 text-sm">Access a clean overview of income, balances, and outstanding dues.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invoicing;
